import Layout from '@/components/feature/Layout';
import useSEO from '@/hooks/useSEO';
import SEOJsonLd from '@/components/base/SEOJsonLd';
import ContactFormContent from './components/ContactFormContent';

export default function ContactFormPage() {
  const siteUrl = (window as any).__VITE_SITE_URL__ || 'https://kangyong.com';
  useSEO({
    title: '聯絡表單｜保健食品代工洽詢・專人回覆｜康永生技',
    description: '填寫康永生技保健食品代工洽詢表單：提供產品類型、預計數量、配方需求等資訊，專人 1 個工作天內回覆。也可透過 LINE、電話、Email 直接聯繫。',
    keywords: '聯絡表單,代工洽詢,保健食品詢價,ODM OEM 諮詢,康永聯絡',
    lang: 'zh-TW',
    canonicalPath: '/contact/form',
  });

  return (
    <Layout>
      <SEOJsonLd type="WebPage" pageTitle="聯絡表單｜保健食品代工洽詢・專人回覆｜康永生技" pageDescription="填寫康永生技保健食品代工洽詢表單：提供產品類型、預計數量、配方需求等資訊，專人 1 個工作天內回覆。" pageUrl={`${siteUrl}/contact/form`} />
      <ContactFormContent />
    </Layout>
  );
}